import { FlashList, type FlashListProps } from "@shopify/flash-list";

type RefreshableListProps<T> = Omit<
  FlashListProps<T>,
  "refreshControl" | "refreshing" | "onRefresh"
> & {
  /** Native only, ignored on web — there is no pull gesture in the browser */
  onRefresh: () => Promise<unknown>;
};

export function RefreshableList<T>({
  onRefresh: _onRefresh,
  ...listProps
}: RefreshableListProps<T>) {
  return <FlashList {...listProps} />;
}
